// extracted by mini-css-extract-plugin
export default {"success__message":"SuccessMessage_success__message__Weffa"};